import { render, staticRenderFns } from "./SkeletonStore.vue?vue&type=template&id=1d729d85"
import script from "./SkeletonStore.vue?vue&type=script&lang=js"
export * from "./SkeletonStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports